<template>
  <div id="mySearch">
    <div id="searchDiv" v-for="(item,index) in searchItems">
      <el-select class="select" v-model="item.value" placeholder="请选择筛选条件" @change="a($event,index)">
        <el-option
                v-for="item2 in searchParams"
                :key="item2.key"
                :label="item2.value"
                :value="item2.key">
        </el-option>
      </el-select>
      <el-select v-if="item.isSelect" class="input" v-model="item.input" placeholder="请选择搜索内容">
        <el-option
                v-for="item2 in item.isSelect"
                :key="item2.key"
                :label="item2.value"
                :value="item2.key">
        </el-option>
      </el-select>
      <el-input v-else class="input" v-model="item.input" placeholder="请输入搜索内容"></el-input>
      <el-button id="del" v-if="item.del" type="danger" @click="del(index)">删除</el-button>
    </div>
    <div id="addSearch">
      <el-button type="primary" @click="addSearch">新增筛选条件</el-button>
      <el-button id="search" type="success" @click="search">搜索</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MySearch",
    props:{
      searchParams: Array,
    },
    data() {
      return {
        searchItems:[
          {value: "",input: "",del:false}
        ]
      }
    },
    methods: {
      a(val,index){
        for (let i = 0;i<this.searchParams.length;i++){
          if (val == this.searchParams[i].key){
            if (this.searchParams[i].isSelect){
              this.$set(this.searchItems[index],"isSelect",this.searchParams[i].isSelect)
              return;
            }
          }
        }
        this.$set(this.searchItems[index],"isSelect",false)
      },
      addSearch(){
        this.searchItems.push({value: "",input: "",del:true});
      },
      search(){
        this.$emit("search",this.searchItems)
      },
      del(index){
        console.log(index);
        this.searchItems.splice(index,1)
      }
    }
  }
</script>

<style scoped>
  #mySearch{
    margin-left: 15px;
    margin-top: 30px;
    position: relative;
  }

  #searchDiv{
    margin-bottom: 5px;
    margin-top: 5px;
  }

  .select{
    display: inline-block;
  }

  .input{
    display: inline-block;
    margin-left: 30px;
    width: 222px;
  }

  #addSearch{
    position: absolute;
    top: 0;
    left: 500px;
  }

  #search{
    margin-left: 30px;
  }

  #del{
    margin-left: 26px;
  }
</style>
